import { render } from "./Trainer.vue?vue&type=template&id=4e62bff3"
import script from "./Trainer.vue?vue&type=script&lang=js"
export * from "./Trainer.vue?vue&type=script&lang=js"

import "./Trainer.vue?vue&type=style&index=0&id=4e62bff3&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__